import React, { useEffect, useState } from 'react';
import '../../../scss/pages/Rewards/RewardConfirmation.scss';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import ConfirmationStar from '../../../asset/svg/ConfirmationStar.svg';
import { useNavigate, useLocation } from 'react-router';
import { REWARDS_PATH } from '../../../utils/Constants';
import RewardCoinLogo from '../../../asset/svg/RewardCoinLogo.svg'
import { Typography } from '@mui/material';
import postAppreciationIcon from '../../../asset/svg/postAppreciationIcon.svg';


function RewardConfirmation() {
    const navigate = useNavigate();
    const location = useLocation();
    const [rewardUserData, setRewardUserData] = useState({ EmpName: '', EmpCode: '', Designation: '', Department: '', ReportingManager: '' },);
    const [rewardedCoins, setRewardedCoins] = useState('')


    useEffect(() => {
        window.scrollTo(0, 0)
        if (location.state.userViewedData) {
            const userData = location.state.userViewedData
            setRewardUserData((rewardUserData) => ({ ...rewardUserData, EmpName: userData.EmpName, EmpCode: userData.EmpCode, Designation: userData.Designation, Department: userData.Department, ReportingManager: userData.ReportingManager }));
        }
        if (location.state?.rewardCoins) {
            const { rewardCoins } = location.state
            setRewardedCoins(rewardCoins)
        }
    }, [location.state?.userViewedData, location.state?.rewardCoins])

    const handleGoHome = () => {
        navigate(REWARDS_PATH)
    }


    return (
        <div className='confirmRewardsContainer'>
            <div className='confirmRewardsContainer_header'>
                <img className='confirmRewardsContainer_header_image' src={LeftArrow} alt="" onClick={handleGoHome} />&nbsp;&nbsp;&nbsp;
            </div>
            <div className='confirmRewardsContainer_bodyContainer'>
                <div>
                    <div className='confirmRewardsContainer_bodyContainer_confirmationStarContainer'>
                        <img className='confirmRewardsContainer_bodyContainer_confirmationStarContainer_confirmationStar' src={ConfirmationStar} alt="" />&nbsp;&nbsp;&nbsp;
                    </div>
                    <div className='confirmRewardsContainer_bodyContainer_rewardCoinsContainer'>
                        <img src={RewardCoinLogo} alt="" />&nbsp;&nbsp;&nbsp;
                        <span className='confirmRewardsContainer_bodyContainer_rewardCoinsContainer_rewardcoins'>{rewardedCoins}</span>
                    </div>
                    <div className='confirmRewardsContainer_bodyContainer_rewardcontentContainer'>
                        <Typography className='confirmRewardsContainer_bodyContainer_rewardcontentContainer_rewardcontent'>Rewards sent to</Typography>
                    </div>
                    <div className='confirmRewardsContainer_bodyContainer_rewardNameContainer'>
                        <Typography className='confirmRewardsContainer_bodyContainer_rewardNameContainer_rewardName'>{rewardUserData?.EmpName}</Typography>
                    </div>
                </div>
                <div className='confirmRewardsContainer_bodyContainer_PostAppriciationContainer'>
                    <div className='confirmRewardsContainer_bodyContainer_PostAppriciationContainer_content'>
                        <Typography color='#FFF' fontSize='14px' fontWeight={600} lineHeight='16px'>Post Appreciations</Typography>
                        <Typography color='rgba(255,255,255,0.5)' fontSize='12px' fontWeight={400} lineHeight='16px'>Post an appreciation note to your colleagues</Typography>
                        <a className='buttonPress' href="openFeed" style={{ cursor: 'pointer', color: '#8074FF', fontSize: '14px', fontWeight: 700, lineHeight: '14px', textDecoration: 'none' }}>Post Now</a>
                    </div>
                    <div className='confirmRewardsContainer_bodyContainer_PostAppriciationContainer_imageContainer'>
                        <img className='confirmRewardsContainer_bodyContainer_PostAppriciationContainer_imageContainer_image' src={postAppreciationIcon} alt="" />&nbsp;&nbsp;&nbsp;
                    </div>
                </div>
                <div className='confirmRewardsContainer_bodyContainer_rewardButtonContainer'>
                    <button className='confirmRewardsContainer_bodyContainer_rewardButtonContainer_sendAnotherButton' onClick={handleGoHome}>Send Another</button>
                </div>
            </div>
        </div>

    )
}

export default RewardConfirmation